import {hasher} from 'hasher';
import * as ko from "knockout";
import {IFormTemplate, IObjectData} from "../../../../../index";
import {IDialogOptionsComponent} from "../../../../dialog/index";
import {IPickerOptions} from "../../../../picker/AbstractPicker";
import {ButtonManager} from "../../../../../util/ButtonManager";
import {getCancelButton, getContinueButton} from "../../../../../constants/RouteDefinitions";
import {nsRoute} from "../../../../../util/route";
import ButtonOrder = nsRoute.ButtonOrder;
import openHtml from './open.html?raw';

export let template = openHtml;

interface IParams {
    form: IFormTemplate
    obj?: IObjectData
    dialog: IDialogOptionsComponent
}

export class viewModel {
    private toggleTarget: KnockoutObservable<boolean> = ko.observable(false);
    private toggleMode: KnockoutObservable<'preview' | 'full'> = ko.observable<'preview' | 'full'>('preview');
    private selectedUser: KnockoutObservable<IObjectData | null> = ko.observable(null);
    private readonly toggleContext: KnockoutObservable<'me' | 'other'> = ko.observable<'me' | 'other'>('me');
    private readonly pageButtons: ButtonManager = new ButtonManager()

    constructor(private params: IParams) {
        this.pageButtons.add(getCancelButton(() => this.params.dialog.doClose?.()))
        this.pageButtons.add(getContinueButton({
            label: 'open subject|s:((form))',
            onClick: () => this.onSubmit(),
            order: ButtonOrder.SUBMIT,
        }))
    }

    getPickerUserOptions(): IPickerOptions<IObjectData> {
        return {
            observable: this.selectedUser,
            label: 'choose subject|s:((user|ac))',
            placeholder: 'choose subject|s:((user|ac))',
        }
    }

    private onSubmit() {
        const parts = [];
        parts.push(this.params.form.companyid);
        parts.push(this.params.form.id);
        parts.push(this.selectedUser()?.id ?? this.params.obj?.id ?? 0);
        parts.push(this.toggleMode() == 'preview' ? 1: 0);
        const path = `formview/${parts.join('/')}`;
        if (this.toggleTarget()) {
            window.open(`win.html#/${path}`, '_blank');
        } else {
            hasher.setHash(path);
        }
        this.params.dialog.doClose?.();
    }
}
